export const eventTickets = (params: { eventId: number }) => `event:${params.eventId}`;
